import React from 'react';
import { MarkdownDoc, ParagraphText } from '../../../Markdown';
import { MarkdownDocTabProps } from './types';
import { useRemoteMarkdownDoc } from './useRemoteMarkdownDoc';

const DEFAULT_LOADING_TEXT = 'Loading article...';
const DEFAULT_ERROR_TEXT =
  'Unable to load this article. Please try again later.';
const DEFAULT_EMPTY_TEXT = 'This tab content is unavailable.';

export function MarkdownDocTab({
  sourceUrl,
  title,
  loadingText = DEFAULT_LOADING_TEXT,
  errorText = DEFAULT_ERROR_TEXT,
  emptyText = DEFAULT_EMPTY_TEXT,
}: MarkdownDocTabProps) {
  const { markdown, isLoading, hasError } = useRemoteMarkdownDoc(sourceUrl);

  if (!sourceUrl) {
    return <ParagraphText>{emptyText}</ParagraphText>;
  }

  if (isLoading) {
    return <ParagraphText>{loadingText}</ParagraphText>;
  }

  if (hasError) {
    return <ParagraphText>{errorText}</ParagraphText>;
  }

  if (!markdown) {
    return <ParagraphText>{emptyText}</ParagraphText>;
  }

  return <MarkdownDoc title={title} markdown={markdown} variant="tab" />;
}
